import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import css from './FocalPointPicker.module.scss';

const FocalPointPicker = ({imageSrc, focalPoint, onChange}) => {
  const imageRef = useRef(null);

  const handleClick = (e) => {
    const rect = imageRef.current.getBoundingClientRect();
    const x = Math.round(((e.clientX - rect.left) / rect.width) * 100) / 100;
    const y = Math.round(((e.clientY - rect.top) / rect.height) * 100) / 100;
    onChange({x, y});
  }

  if (!imageSrc) {
    return null;
  }

  return (
    <div className={css.container}>
      <img
        ref={imageRef}
        src={imageSrc}
        alt=""
        className={css.image}
        onClick={handleClick}
      />
      {focalPoint &&
        <div
          className={css.pin}
          style={{
            left: `${focalPoint.x * 100}%`,
            top: `${focalPoint.y * 100}%`,
          }}
        />
      }
    </div>
  )
};

FocalPointPicker.propTypes = {
  imageSrc: PropTypes.string,
  focalPoint: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),
  onChange: PropTypes.func.isRequired,
};

export default FocalPointPicker;
